var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 35C4 52.1208 17.8792 66 35 66C52.1208 66 66 52.1208 66 35C66 17.8792 52.1208 4 35 4C17.8792 4 4 17.8792 4 35ZM35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0Z",
    fill: "#AFB7BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3333 21H25.6667L25.6667 27H28.3333V21ZM31 23V19C31 17.8954 29.8061 17 28.3333 17H25.6667C24.1939 17 23 17.8954 23 19V23H19C17.8954 23 17 23.8954 17 25V30V35V37V42V44V51C17 52.1046 17.8954 53 19 53H51C52.1046 53 53 52.1046 53 51V44V42V37V35V30V25C53 23.8954 52.1046 23 51 23H47V19C47 17.8954 45.8061 17 44.3333 17H41.6667C40.1939 17 39 17.8954 39 19V23H31ZM49 35V30H44V35H49ZM42 35V30H36V35H42ZM34 35H28V30H34V35ZM34 37V42H28V37H34ZM36 42V37H42V42H36ZM34 44H28V49H34V44ZM36 49V44H42V49H36ZM44 44V49H49V44H44ZM44 37V42H49V37H44ZM26 35V30H21V35H26ZM21 37H26V42H21V37ZM21 49V44H26V49H21ZM44.3333 21V27H41.6667V21H44.3333Z",
    fill: "#AFB7BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCalendar);
export default __webpack_public_path__ + "static/media/circle-calendar.3f6c8e62230b70199304ce41cafcdd68.svg";
export { ForwardRef as ReactComponent };